/*
 * CERA DESIGN — storefront behaviour.
 * Header (mega menu, mobile nav, scroll border), cart drawer via the Shopify
 * Section Rendering API, PDP variant picker and sticky buy bar.
 */
(function () {
  'use strict';

  var SECTION = 'cart-drawer';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* The header, mega menu and mobile nav moved to cera-header.js when the
     header was rebuilt from the prototype. Nothing here queried markup that
     still exists. */


  /* --------------------------------------------------------------- cart --- */

  function drawer() { return $('[data-cera-cart]'); }
  function scrim() { return $('[data-cera-scrim]'); }

  function openCart() {
    var d = drawer();
    if (!d) return;
    d.classList.add('on');
    d.setAttribute('aria-hidden', 'false');
    if (scrim()) scrim().classList.add('on');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('on');
    d.setAttribute('aria-hidden', 'true');
    if (scrim()) scrim().classList.remove('on');
    document.body.style.overflow = '';
  }

  function setBusy(state) {
    busy = state;
    var d = drawer();
    if (d) d.classList.toggle('busy', state);
  }

  function paint(html) {
    var d = drawer();
    if (!d || !html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var next = parsed.querySelector('[data-cera-cart]');
    if (!next) return;
    var wasOpen = d.classList.contains('on');
    d.innerHTML = next.innerHTML;
    if (wasOpen) d.classList.add('on');
  }

  function syncCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    var n = cart.item_count;

    $$('[data-cera-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('on', n > 0);
    });

    // Restart the bump: drop the class, force a reflow so the browser sees
    // the removal, then add it back.
    $$('.hd-bag').forEach(function (bag) {
      bag.classList.remove('bump');
      void bag.offsetWidth;
      if (n) bag.classList.add('bump');
    });
  }

  function post(url, body) {
    if (busy) return Promise.resolve(null);
    setBusy(true);
    body.sections = [SECTION];
    body.sections_url = window.location.pathname;

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.sections && data.sections[SECTION]) paint(data.sections[SECTION]);
        syncCount(data);
        return data;
      })
      .catch(function (err) { console.error('[cera]', err); return null; })
      .finally(function () { setBusy(false); });
  }

  function refresh() {
    // Reward gifts are real cart lines, so settle them before repainting —
    // otherwise the drawer shows a cart the gift sync is about to change.
    var settled =
      window.CeraDrawer && window.CeraDrawer.syncGifts
        ? window.CeraDrawer.syncGifts()
        : Promise.resolve();

    return settled
      .then(function () {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        syncCount(cart);
        return fetch(root + '?sections=' + SECTION);
      })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data && data[SECTION]) paint(data[SECTION]); })
      .catch(function (err) { console.error('[cera]', err); });
  }

  function addVariant(id, quantity) {
    return post(root + 'cart/add.js', { items: [{ id: Number(id), quantity: quantity || 1 }] })
      .then(refresh)
      .then(openCart);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cera-cart-toggle]')) {
      e.preventDefault();
      openCart();
      return;
    }
    if (e.target.closest('[data-cera-cart-close]')) {
      e.preventDefault();
      closeCart();
      return;
    }
    if (e.target.closest('[data-cera-scrim]')) {
      closeCart();
      return;
    }

    /* Quantity steppers and line removal belong to cera-drawer.js, which
       matches the current drawer markup. Handling them here as well fired
       both listeners on one click. */

    var add = e.target.closest('[data-cera-add]');
    if (add) {
      e.preventDefault();
      addVariant(add.dataset.ceraAdd, 1);
    }
  });

  /* Intercept add-to-cart forms so the drawer opens instead of a page load */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    if (form.dataset.ceraSkipDrawer === 'true') return;

    e.preventDefault();
    var data = new FormData(form);
    setBusy(true);

    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message);
        return refresh();
      })
      .then(openCart)
      .catch(function (err) {
        console.error('[cera]', err);
        form.dataset.ceraSkipDrawer = 'true';
        form.submit();
      })
      .finally(function () { setBusy(false); });
  });

  /* ---------------------------------------------------------------- PDP --- */

  function initProduct() {
    var form = $('[data-cera-product]');
    if (!form) return;

    var dataEl = $('[data-cera-variants]', form);
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = $('[data-cera-variant-id]', form);
    var priceEl = $('[data-cera-price]');
    var compareEl = $('[data-cera-compare]');
    var submitEl = $('[data-cera-submit]', form);
    var moneyFormat = form.dataset.moneyFormat || '${{amount}}';

    function money(cents) {
      var amount = (cents / 100).toFixed(2);
      if (moneyFormat.indexOf('amount_no_decimals') > -1) amount = Math.round(cents / 100).toString();
      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, amount);
    }

    function selected() {
      return $$('[data-cera-option]', form).map(function (group) {
        var on = group.querySelector('[aria-pressed="true"]');
        return on ? on.dataset.value : null;
      });
    }

    function match() {
      var want = selected();
      return variants.find(function (v) {
        return want.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function render() {
      var v = match();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (submitEl) {
        submitEl.disabled = !v.available;
        submitEl.textContent = v.available
          ? submitEl.dataset.available || 'Add to bag'
          : submitEl.dataset.soldOut || 'Sold out';
      }
      $$('[data-cera-sticky-price]').forEach(function (n) { n.textContent = money(v.price); });

      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }

    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-value]');
      if (!btn) return;
      e.preventDefault();
      var group = btn.closest('[data-cera-option]');
      $$('[data-value]', group).forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      var label = $('[data-cera-option-value]', group);
      if (label) label.textContent = btn.dataset.value;
      render();
    });

    var qtyInput = $('[data-cera-qty-input]', form);
    form.addEventListener('click', function (e) {
      var step = e.target.closest('[data-cera-qty-step]');
      if (!step || !qtyInput) return;
      e.preventDefault();
      var next = parseInt(qtyInput.value, 10) + (step.dataset.ceraQtyStep === 'up' ? 1 : -1);
      qtyInput.value = Math.max(1, next);
      var out = $('[data-cera-qty-out]', form);
      if (out) out.textContent = qtyInput.value;
    });

    render();
  }

  /* --------------------------------------------------------- sticky buy --- */

  function syncSticky() {
    var bar = $('[data-cera-sticky]');
    if (!bar) return;
    var anchor = $('[data-cera-submit]');
    bar.classList.toggle('show', !!anchor && anchor.getBoundingClientRect().bottom < 0);
  }

  /* ---------------------------------------------------------------- go ---- */

  function init() {
    // header lives in cera-header.js
    initProduct();
    syncSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.CeraCart = { open: openCart, close: closeCart, refresh: refresh, add: addVariant };
})();
